module.exports = __webpack_public_path__ + "img/cert.2296a107.png";